export default __webpack_public_path__ + "static/freeWorkshop-a20a8c897a1aa6158d9e3cc95656c973.png";